import { BodyTd, TableBody, TableBodyRow } from './typography'

export default function FinalizedReportDetailsTable({
  items
}: {
  items: {
    title: string
    value: React.ReactNode
  }[]
}) {
  const itemsWithActualValue = items.filter(item => !!item.value)
  return (
    <table className="w-full text-left">
      <thead>
        <tr>
          <th className="py-1.5 px-3 font-semibold">Field</th>
          <th className="py-1.5 px-3 font-semibold text-right">Value</th>
        </tr>
      </thead>
      <TableBody>
        {itemsWithActualValue.map(
          (item, index) =>
            item.value && (
              <TableBodyRow key={index}>
                <BodyTd>{item.title}</BodyTd>
                <BodyTd className="text-right">{item.value}</BodyTd>
              </TableBodyRow>
            )
        )}
      </TableBody>
    </table>
  )
}
